import React, {Fragment} from 'react';
import {PeopleEditCommon} from './PeopleEditCommon';



const PeopleEdit = (props) => {
    console.log("props in PeopleEdit", {props});
    return ( <PeopleEditCommon {...props}/>);
}


export default PeopleEdit;